import { useLoggedInUserData } from "../../../utils/user";
import ScreenDashboardAdminGroupsHierarchy from "./groups.hierarchy";
import ScreenDashboardAdminGroupsListing from "./groups.listing";

const ScreenDashboardAdminGroups = () => {
  const accountHasGroupHierarchyEnabled = useLoggedInUserData('groupHierarchy');
  return (
    <>
      {accountHasGroupHierarchyEnabled === '1' ? (
        <ScreenDashboardAdminGroupsHierarchy />
      ) : (
        <ScreenDashboardAdminGroupsListing />
      )}
    </>
  );
}
export default ScreenDashboardAdminGroups;